var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loading',{staticClass:"loading-wrapper",class:{'is-enterprise': _vm.isEnterprise},attrs:{"size":70,"width":7,"color":"white"}})
}
var staticRenderFns = []

export { render, staticRenderFns }